import React from "react";

export const STATUS_COLORS = {
  active: "#0AD69F",
  missing: "#EF476F",
  inactive: "#A8ADC3",
};

const CONNECTOR_CLASS = "w-2 h-[2px] bg-[#043F88]";
const CHIP_CLASS = "px-[5px] py-1 rounded-[10px] font-semibold text-[12px] text-white";

const StatusChain = ({ items = [], className = "" }) => {
  const visible = items.filter(Boolean);
  const wrapperClass = `flex items-center flex-wrap${className ? ` ${className}` : ""}`;

  return (
    <div className={wrapperClass}>
      {visible.map((item, i) => {
        const color = item.color || STATUS_COLORS.active;
        const isClickable = typeof item.onClick === "function";
        const chipClass = `${CHIP_CLASS}${isClickable ? " cursor-pointer" : ""}`;

        return (
          <React.Fragment key={item.key ?? i}>
            {i > 0 && <div className={CONNECTOR_CLASS} />}
            <span
              className={chipClass}
              style={{ backgroundColor: color }}
              onClick={isClickable ? item.onClick : undefined}
            >
              {item.label}
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StatusChain;
